import { H3, P2 } from 'au-gatsby-ds/components';
import { mediaQuery } from 'components';
import styled from 'styled-components';

export const FAQContainer = styled.div`
  margin-bottom: 16px;
`;

export const FAQLinkContainer = styled.div`
  display: flex;
  background: #fafafa;
  border-radius: 8px;
`;

export const FAQLink = styled.div<{ showOnMobile: boolean }>`
  ${P2}

  margin: 32px;
  text-align: center;

  ${props =>
    !props.showOnMobile &&
    `
      display: none;
    `}
  ${mediaQuery.medium`
    display: block;
    text-align: left;
  `}

  a {
    display: inline-block;
    margin-top: 8px;
    font-weight: 700;
    text-decoration-line: underline !important;
    color: #333333;
  }
`;

export const FAQHeader = styled.div`
  padding-bottom: 18px;
  margin-bottom: 32px;
  border-bottom: solid 1px #e6e6e6;
  ${H3}
`;
